import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-card-label',
    templateUrl: './card-label.component.html',
    styleUrls: ['./card-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardLabelComponent implements OnInit {
  @Input() cssClass: string;
  @Input() label: string;
  @Input() show: boolean;
  @Input() icon: string;

  constructor() { }

  ngOnInit() {
  }

}
